import { observer } from "mobx-react-lite"
import { useEffect, useRef } from "react"
import { usePrintStore } from "reusable/printing/PrintStore"
import Box from '@mui/material/Box';

/** Creates a static copy of content and appends to document.body for printing */
export default observer(() => {
   const printStore = usePrintStore()
   const printContainerRef = useRef<HTMLElement>()

   useEffect(() => {
      if (printContainerRef.current && printStore.contentNode) {
         printContainerRef.current.innerHTML = ''
         printContainerRef.current.appendChild(printStore.contentNode)
      }
   }, [printContainerRef, printStore.contentNode])

   return (
      <Box ref={printContainerRef} className="print-container" sx={{
         '@media screen': {
            display: 'none'
         },
         '& *': {
            '@media screen': {
               display: 'none',
            }
         },
      }} />
   )
})
